import { jsx as t, jsxs as f, Fragment as H } from "react/jsx-runtime";
import L, { useState as Z, useEffect as M } from "react";
import { z as l } from "zod";
import { withZod as _ } from "@made-people/react-prop-guard";
import { withManagedProps as G } from "@made-people/managed-props";
import { Drawer as R } from "@made-people/blueprint-drawer";
import { filterGlasgowBlueprint as b } from "./index-blueprint.es.js";
import { useFacets as P, useSort as V, useSearchResultMeta as W } from "@made-people/grease-search";
import { useTranslate as A } from "@made-people/grease-translations";
import { Accordion as $ } from "@made-people/blueprint-accordion";
import { Checkbox as k } from "@made-people/blueprint-form";
import D from "clsx";
import { buttonAsButtonSchema as B, ButtonAsButton as w } from "@made-people/blueprint-button";
import { overlayEventEmitter as U } from "@made-people/blueprint-overlay";
import { CrossIcon as K } from "@made-people/blueprint-icons";
import { headingSchema as p, Heading as q } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const J = ({
  facet: e,
  toggleFacet: i
}) => {
  const n = b.main.styles(), c = A();
  return e.type !== "group" ? null : /* @__PURE__ */ t("div", { className: n.filterGroupedContainer, children: e.children.map((o) => /* @__PURE__ */ f("div", { className: n.filterGroupedSection, children: [
    /* @__PURE__ */ t("div", { className: n.filterSubheading, children: c(`Filter_${o.name}`) }),
    /* @__PURE__ */ t("div", { className: n.filterGroupedGrid, children: o.values.map((a) => /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: n.filterGroupedButton,
        "data-selected": a.selected,
        onClick: () => {
          i(o.id, a.id);
        },
        children: a.name
      },
      a.id
    )) })
  ] }, o.id)) });
}, z = (e) => {
  const {
    value: i,
    filterId: n,
    toggleFacet: c,
    expandedIds: o,
    handleToggleExpand: a,
    checkBoxClassName: g
  } = e, h = !!(i.children && i.children.length > 0), d = o.has(i.id), s = b.main.styles();
  return /* @__PURE__ */ f(H, { children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: s.filterOptionHierarchicalItem,
        style: { marginLeft: `${i.level * 12}px` },
        children: [
          /* @__PURE__ */ t(
            k,
            {
              checked: i.selected,
              label: i.name,
              className: D(g, "w-full"),
              onChange: () => {
                c(n, i.id);
              }
            }
          ),
          h && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: s.filterOptionHierarchicalItemButton,
              "aria-label": `Toggle ${i.name}`,
              "aria-expanded": d,
              onClick: () => a(i.id),
              onKeyDown: (m) => {
                (m.key === "Enter" || m.key === " ") && (m.preventDefault(), a(i.id));
              },
              tabIndex: 0,
              children: d ? "−" : "+"
            }
          )
        ]
      }
    ),
    h && d && /* @__PURE__ */ t("div", { className: s.filterOptionHierarchicalList, children: i.children.map((m) => /* @__PURE__ */ t(
      z,
      {
        value: m,
        filterId: n,
        toggleFacet: c,
        expandedIds: o,
        handleToggleExpand: a
      },
      m.id
    )) })
  ] });
}, Q = ({
  facet: e,
  toggleFacet: i,
  expandedIds: n,
  handleToggleExpand: c
}) => {
  const o = b.main.styles();
  return e.type === "group" ? null : /* @__PURE__ */ t("div", { className: o.filterOptions, children: e.type === "checkbox-hierarchical" ? e.values.map((a) => /* @__PURE__ */ t(
    z,
    {
      value: a,
      filterId: e.id,
      checkBoxClassName: o.filterOption,
      toggleFacet: i,
      expandedIds: n,
      handleToggleExpand: c
    },
    a.id
  )) : e.type === "checkbox" ? e.values.map((a) => /* @__PURE__ */ t(
    k,
    {
      checked: a.selected,
      label: a.name,
      className: o.filterOption,
      onChange: () => {
        i(e.id, a.id);
      }
    },
    a.id
  )) : null });
}, X = ({
  facet: e,
  toggleFacet: i,
  expandedIds: n,
  handleToggleExpand: c
}) => e.type === "group" ? /* @__PURE__ */ t(
  J,
  {
    facet: e,
    toggleFacet: i,
    expandedIds: n,
    handleToggleExpand: c
  }
) : /* @__PURE__ */ t(
  Q,
  {
    facet: e,
    toggleFacet: i,
    expandedIds: n,
    handleToggleExpand: c
  }
), O = l.object({
  template: l.literal("glasgow").optional(),
  variants: l.custom().optional(),
  checkboxIndicator: l.custom().optional(),
  accordion: l.any().optional(),
  sortEnabled: l.boolean().optional(),
  actions: l.object({
    apply: B.optional(),
    clear: B.or(l.literal(!1)).optional()
  }).optional(),
  applyButtonVariants: l.custom().optional(),
  clearButtonVariants: l.custom().optional(),
  className: l.string().optional(),
  activeFilters: l.object({
    enabled: l.boolean().optional(),
    icon: l.custom().optional(),
    buttonVariants: l.custom().optional(),
    heading: p.or(l.literal(!1)).optional(),
    clearFilterEnabled: l.boolean().optional()
  }).optional()
}), Y = G(
  "FilterGlasgow",
  _(
    {
      schema: O,
      defaultProps: {
        sortEnabled: !1,
        actions: {
          clear: {
            variants: {
              width: "full",
              color: "black",
              style: "outline",
              size: "lg"
            }
          },
          apply: {
            variants: {
              width: "full",
              color: "black",
              style: "solid",
              size: "lg"
            }
          }
        },
        activeFilters: {
          enabled: !0,
          icon: /* @__PURE__ */ t(K, {}),
          heading: {
            heading: "Filter_ActiveFilters",
            variants: { headingSize: "sm" }
          }
        }
      }
    },
    (e) => {
      var F, y, N, x, S, C, E, I;
      const { facets: i, toggleFacet: n, resetFacets: c, activeFacetValues: o } = P(), { sortAlternatives: a, toggleSort: g } = V(), h = W(), d = A(), s = b.main.styles(), [m, T] = L.useState(
        () => /* @__PURE__ */ new Set()
      ), j = (r) => {
        T((v) => {
          const u = new Set(v);
          return u.has(r) ? u.delete(r) : u.add(r), u;
        });
      };
      return /* @__PURE__ */ f("div", { className: D(s.base, e.className), children: [
        /* @__PURE__ */ t("div", { className: s.filterHeader, children: /* @__PURE__ */ t("h4", { className: s.filterHeaderTitle, children: d("Filter_Header_Title") }) }),
        ((F = e.activeFilters) == null ? void 0 : F.enabled) && o.length > 0 && /* @__PURE__ */ f("div", { className: s.activeFilters, children: [
          ((y = e.activeFilters) == null ? void 0 : y.heading) && /* @__PURE__ */ t(q, { ...e.activeFilters.heading }),
          /* @__PURE__ */ f("div", { className: s.activeFiltersList, children: [
            e.activeFilters.clearFilterEnabled && /* @__PURE__ */ t(
              w,
              {
                onClick: c,
                variants: {
                  width: "auto",
                  style: "solid",
                  size: "sm",
                  ...(N = e.activeFilters) == null ? void 0 : N.buttonVariants
                },
                iconRight: (x = e.activeFilters) == null ? void 0 : x.icon,
                label: d("Filter_Clear_All"),
                ...(S = e.actions) == null ? void 0 : S.clear
              }
            ),
            o.map((r) => {
              var v, u;
              return /* @__PURE__ */ t(
                w,
                {
                  iconRight: (v = e.activeFilters) == null ? void 0 : v.icon,
                  variants: {
                    width: "auto",
                    style: "solid",
                    size: "sm",
                    ...(u = e.activeFilters) == null ? void 0 : u.buttonVariants
                  },
                  onClick: () => {
                    n(
                      r.facetId,
                      r.id
                    );
                  },
                  label: r.name
                },
                r.id
              );
            })
          ] })
        ] }),
        /* @__PURE__ */ t(
          $,
          {
            ...e.accordion,
            blueprint: b.accordion,
            items: [
              ...e.sortEnabled && a.length > 0 ? [
                {
                  content: {
                    value: "sort",
                    trigger: d("Filter_Sort_Title"),
                    content: /* @__PURE__ */ t("div", { className: s.filterOptions, children: a.map((r) => /* @__PURE__ */ t(
                      k,
                      {
                        checked: r.selected,
                        label: r.name,
                        className: s.filterOption,
                        onChange: () => {
                          g(r.id);
                        }
                      },
                      r.id
                    )) })
                  }
                }
              ] : [],
              ...i.map((r) => ({
                content: {
                  value: r.id,
                  trigger: d(r.name),
                  content: /* @__PURE__ */ t(
                    X,
                    {
                      facet: r,
                      toggleFacet: n,
                      expandedIds: m,
                      handleToggleExpand: j
                    }
                  )
                }
              }))
            ]
          }
        ),
        /* @__PURE__ */ f("div", { className: s.bottomRow, children: [
          ((C = e.actions) == null ? void 0 : C.clear) && /* @__PURE__ */ t(
            w,
            {
              onClick: () => {
                c();
              },
              label: d("Filter_Clear_All"),
              ...(E = e.actions) == null ? void 0 : E.clear
            }
          ),
          h && /* @__PURE__ */ t(
            w,
            {
              onClick: () => U.emit("close", { overlayId: "filter" }),
              label: d("Filter_Apply", {
                totalProducts: h.totalItems
              }),
              ...(I = e.actions) == null ? void 0 : I.apply
            }
          )
        ] })
      ] });
    }
  )
), ee = {
  variants: {
    rounded: { initial: "medium", lg: "none" }
  }
}, te = () => {
  const [e, i] = Z(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return M(() => {
    const n = () => {
      i(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), e;
}, ie = l.object({
  as: l.literal("drawer").optional(),
  drawerSettings: l.custom().optional().describe("Settings for the drawer"),
  direction: l.object({
    mobile: l.enum(["left", "top", "bottom", "right"]).optional(),
    desktop: l.enum(["left", "top", "bottom", "right"]).optional()
  }).optional()
}), ne = l.discriminatedUnion("template", [
  O.merge(ie)
]), ye = G(
  "Filter",
  _(
    {
      schema: ne,
      defaultProps: {
        drawerSettings: ee,
        direction: {
          mobile: "bottom",
          desktop: "left"
        }
      }
    },
    (e) => {
      var c, o, a, g, h, d, s, m;
      const i = te();
      let n;
      return e.template === "glasgow" ? n = /* @__PURE__ */ t(Y, { ...e }) : n = null, e.as === "drawer" ? /* @__PURE__ */ t(
        R,
        {
          customOverlayId: "filter",
          variants: {
            rounded: {
              initial: "medium",
              lg: "none"
            },
            direction: i ? ((c = e == null ? void 0 : e.direction) == null ? void 0 : c.desktop) ?? ((o = e == null ? void 0 : e.direction) == null ? void 0 : o.mobile) : ((a = e == null ? void 0 : e.direction) == null ? void 0 : a.mobile) ?? ((g = e == null ? void 0 : e.direction) == null ? void 0 : g.desktop)
          },
          ...e.drawerSettings,
          direction: i ? ((h = e == null ? void 0 : e.direction) == null ? void 0 : h.desktop) ?? ((d = e == null ? void 0 : e.direction) == null ? void 0 : d.mobile) : ((s = e == null ? void 0 : e.direction) == null ? void 0 : s.mobile) ?? ((m = e == null ? void 0 : e.direction) == null ? void 0 : m.desktop),
          children: /* @__PURE__ */ t(R.Content, { children: n })
        }
      ) : /* @__PURE__ */ t(H, { children: n });
    }
  )
), Ne = (e) => /* @__PURE__ */ t("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ t("path", { d: "M7 10l5 5 5-5", fill: "none", stroke: "currentColor", strokeWidth: "2" }) }), xe = (e) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    className: "w-5 h-5",
    ...e,
    children: /* @__PURE__ */ t(
      "path",
      {
        fill: "#000",
        fillRule: "evenodd",
        d: "M2.6422 5.0249a2.93 2.93 0 0 1 4.9042 1.3218H19.25a.75.75 0 0 1 0 1.5H7.5464a2.9298 2.9298 0 0 1-4.9042 1.3218 2.9298 2.9298 0 0 1-.7606-1.3218H.75a.75.75 0 0 1 0-1.5h1.1316a2.9298 2.9298 0 0 1 .7606-1.3218Zm2.0718.6418a1.43 1.43 0 1 0 0 2.86 1.43 1.43 0 0 0 0-2.86Zm4.5352 5.9652a2.93 2.93 0 0 1 4.144.0001c.3687.3688.6295.8257.7611 1.3217H19.25a.75.75 0 0 1 0 1.5h-5.0957a2.931 2.931 0 0 1-2.8333 2.181c-.778 0-1.523-.3103-2.0718-.8592a2.9296 2.9296 0 0 1-.7606-1.3218H.75a.75.75 0 0 1 0-1.5h7.7386a2.9296 2.9296 0 0 1 .7606-1.3218Zm2.0718.6418a1.43 1.43 0 0 0-1.0112 2.4412 1.431 1.431 0 0 0 1.0112.4198c.3794 0 .7432-.1507 1.0115-.419a1.4319 1.4319 0 0 0 .4195-1.012c0-.3788-.1508-.7423-.4195-1.011a1.4304 1.4304 0 0 0-1.0115-.419Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  Ne as ArrowDown,
  X as FacetContentRenderer,
  ye as Filter,
  Y as FilterGlasgow,
  xe as FilterIcon,
  J as GroupedFacetRenderer,
  z as HierarchicalFacetValue,
  Q as RegularFacetRenderer,
  O as filterGlasgowSchema,
  ne as filterSchema
};
//# sourceMappingURL=index.es.js.map
